// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)
